import { useEffect, useRef } from 'preact/hooks'
import SwiperCarouselInstance from 'customs/swiper-carousel'
import { Fragment } from 'preact'
import Icon from 'snippets/icon/icon'

export default function CarouselSwiper({ heading, items, options, navigation = false, customNavigation = false, pagination = false, scrollbar = true, className = '', setCarouselInstance = () => {} }) {
  const config = { navigation, pagination, scrollbar }
  const swiperRef = useRef(null)
  const swiperContainerRef = useRef(null)

  useEffect(() => {
    const setRefCallback = () => {
      setCarouselInstance(swiperContainerRef.current?.swiper)
    }
    const carousel = new SwiperCarouselInstance(swiperRef.current, options, config, setRefCallback)
  }, [])

  const handleArrowClick = (event) => {
    event.stopPropagation()
    event.preventDefault()
  }

  return items && (
    <div ref={swiperRef} className={`swiper-wrapper ${className}`}>
      {heading}
      <swiper-container
        className="js-carousel-swiper"
        init="false"
        ref={swiperContainerRef}
      >
        {items}
      </swiper-container>
      {navigation && !customNavigation && (
        <Fragment>
          <div className="swiper-button-navigation swiper-button-prev js-carousel-prev" onClick={handleArrowClick}>
            <Icon name="icon-chevron-left" viewBox="0 0 20 20" className="w-5 h-5 text-grey-1000"/>
          </div>
          <div className="swiper-button-navigation swiper-button-next js-carousel-next" onClick={handleArrowClick}>
            <Icon name="icon-chevron-right" viewBox="0 0 20 20" className="w-5 h-5 text-grey-1000"/>
          </div>
        </Fragment>
      )}
      {pagination && <div class="swiper-pagination js-carousel-pagination"></div>}
      {scrollbar && <div class="swiper-scrollbar js-carousel-scrollbar"></div>}
    </div>
  )
}
